// @ts-strict-ignore
import { CheckCircle,CreditCard, Pencil } from "lucide-react";
import React from "react";

import Card from "./Card";

const bullet: React.CSSProperties = { display: "flex", alignItems: "center", gap: 8 };

const CurrentPlanCard: React.FC = () => {
  return (
    <Card title="My Current Plan">
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 12 }}>
        {/* Left gradient panel */}
        <div
          style={{
            borderRadius: 12,
            padding: 16,
            color: "#fff",
            background:
              "linear-gradient(140deg, rgba(33,150,243,1) 0%, rgba(123,31,162,1) 55%, rgba(88,28,135,1) 100%)",
          }}
        >
          <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 6 }}>200 USD/mo</div>
          <div style={{ opacity: 0.95, marginBottom: 12 }}>WSM Team Plan</div>
          <div style={{ display: "grid", gap: 6 }}>
            <div style={bullet}><CheckCircle size={16} /> <span>5 Team Member Licenses</span></div>
            <div style={bullet}><CheckCircle size={16} /> <span>Access to WSM AI</span></div>
            <div style={bullet}><CheckCircle size={16} /> <span>24/7 Expert Support Services</span></div>
          </div>
        </div>

        {/* Right column: payment + next billing */}
        <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", gap: 12 }}>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: 12,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <div style={{ fontWeight: 600 }}>Payment Method</div>
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                title="Edit"
              >
                <Pencil size={16} />
              </button>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <CreditCard size={24} />
              <div>
                <div style={{ letterSpacing: 2, fontWeight: 600 }}>**** **** **** 4242</div>
                <div style={{ color: "#6b7280", fontSize: 12 }}>Expires 12/26</div>
              </div>
            </div>
          </div>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: 12,
            }}
          >
            <div style={{ color: "#6b7280", marginBottom: 6 }}>Next Billing</div>
            <div style={{ fontSize: 28, fontWeight: 800 }}>$200</div>
            <div style={{ color: "#6b7280", fontSize: 12 }}>on 15 Aug, 2025</div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CurrentPlanCard;
